import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CreditCardPayRoutingModule } from './credit-card-pay-routing.module';
import { CreditCardPayComponent } from './credit-card-pay.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OtpPageComponent } from './otp-page/otp-page.component';
import { PublicSharedModule } from 'src/app/public-website/public-shared/public-shared.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CreditCardPayRoutingModule,
    SharedModule,
    PublicSharedModule
  ],
  declarations: [CreditCardPayComponent,OtpPageComponent]
})
export class CreditCardPayModule {}
